<app-side-top-bar [navigationItems]="navigationItems">
  <main>
    <section class="personal-area-page">
      <section class="header">
        <img
          style="border-radius: 50%"
          [src]="profilePicture"
          referrerPolicy="no-referrer"
        />
        <span> Ciao, {{ doctorForm.get("first_name")?.value }} </span>
      </section>

      @if (!isDeletingAccount) {
        <section class="personal-area-form">
          <section class="personal-area-form-header">
            <h2>{{ labelService.getLabel("personal_area") }}</h2>
            <div class="header-buttons">
              @if (isEditing) {
                <app-button
                  [icon]="'delete'"
                  (click)="onCancelClick()"
                ></app-button>
              }
              <app-button
                [icon]="isEditing ? 'save' : 'edit'"
                (click)="isEditing ? onSaveClick() : onEditClick()"
              ></app-button>
            </div>
          </section>
          <form [formGroup]="doctorForm">
            <section class="form-section">
              <h3>{{ labelService.getLabel("Dati Personali") }}</h3>
              <!-- First Row -->
              <div class="form-row">
                <mat-form-field>
                  <mat-label>{{ labelService.getLabel("Nome") }}</mat-label>
                  <input
                    matInput
                    formControlName="first_name"
                    [readonly]="!isEditing"
                  />
                </mat-form-field>
                <mat-form-field>
                  <mat-label>{{ labelService.getLabel("Cognome") }}</mat-label>
                  <input
                    matInput
                    formControlName="last_name"
                    [readonly]="!isEditing"
                  />
                </mat-form-field>
                <mat-form-field>
                  <mat-label>{{ labelService.getLabel("Email") }}</mat-label>
                  <input
                    matInput
                    formControlName="signin_mail"
                    [readonly]="true"
                  />
                </mat-form-field>
              </div>
            </section>
          </form>
          <!-- Subscription Section -->
          <section class="metrics-section">
            <h3>{{ labelService.getLabel("Il mio Abbonamento") }}</h3>
            @if (isSubscriptionActive && !cancelingAtPeriodEnd) {
              <span class="subscription-cancel-note">
                {{
                  labelService.getLabel(
                    "Puoi disdire l'abbonamento entro 10 giorni prima del rinnovo"
                  )
                }}
              </span>
            }
            <div class="metrics-grid">
              <div class="metric-card subscription-card">
                <div class="metric-title">
                  {{ labelService.getLabel("Stato") }}
                </div>
                <div class="metric-value">
                  {{ subscriptionStatus }}
                </div>
              </div>
              @if (shouldShowSubscriptionDateCard) {
                <div class="metric-card subscription-card">
                  <div class="metric-title">{{ subscriptionDateTitle }}</div>
                  <div class="metric-value">{{ subscriptionDateValue }}</div>
                </div>
              }
              <div class="subscription-actions">
                <button
                  mat-stroked-button
                  class="button-white subscription-details-btn"
                  (click)="openStripeClientPortal()"
                  [disabled]="doctorRole === 'admin'"
                >
                  {{ labelService.getLabel("Gestisci Abbonamento") }}
                </button>

                @if (isSubscriptionActive) {
                  <button
                    mat-stroked-button
                    class="button-white subscription-details-btn"
                    style="margin-top: 8px"
                    (click)="toggleSubscriptionAtPeriodEnd()"
                    [disabled]="
                      daysUntilSubscriptionRenewal > 0 &&
                      daysUntilSubscriptionRenewal < 10
                    "
                  >
                    {{
                      labelService.getLabel(
                        cancelingAtPeriodEnd
                          ? "Riattiva Abbonamento"
                          : "Disdici Abbonamento"
                      )
                    }}
                  </button>
                }
              </div>
            </div>
          </section>
          <!-- Usage Section -->
          <section class="metrics-section">
            <h3>{{ labelService.getLabel("Utilizzo") }}</h3>
            @if (usageRequestFailed) {
              <p class="usage-status usage-error">
                {{
                  labelService.getLabel(
                    "Si è verificato un problema nel recupero delle informazioni."
                  )
                }}
              </p>
            } @else if (usage; as usage) {
              <div class="metrics-grid">
                <!-- Storage Card -->
                <div class="metric-card">
                  <div class="metric-title">
                    {{ labelService.getLabel("Storage") }}
                  </div>
                  <div class="progress-bar-container">
                    <div
                      class="progress-bar"
                      [style.width]="(usage.storage_usage / 100) * 100 + '%'"
                      [class.warning]="usage.storage_usage / 100 > 0.8"
                      [class.critical]="usage.storage_usage / 100 > 0.95"
                    ></div>
                  </div>
                  <div class="metric-values">
                    <span>{{ usage.storage_usage }} GB</span>
                    <span class="total">/100 GB</span>
                  </div>
                </div>
                <!-- Patient Pipeline Credits Card -->
                <div class="metric-card">
                  <div class="metric-title">
                    {{
                      labelService.getLabel(
                        "Crediti Utilizzati Analisi Paziente"
                      )
                    }}
                    <mat-icon
                      class="info-icon"
                      matTooltip="I crediti si resettano automaticamente a 60 all'inizio di ogni mese"
                      >update</mat-icon
                    >
                  </div>
                  <div class="progress-bar-container">
                    <div
                      class="progress-bar"
                      [style.width]="
                        ((60 - usage.patient_pipeline_credits) / 60) * 100 + '%'
                      "
                      [class.warning]="60 - usage.patient_pipeline_credits > 40"
                      [class.critical]="
                        60 - usage.patient_pipeline_credits > 55
                      "
                    ></div>
                  </div>
                  <div class="metric-values">
                    <span>{{ 60 - usage.patient_pipeline_credits }}</span>
                    <span class="total">/60</span>
                  </div>
                </div>
                <!-- Appointment Pipeline Credits Card -->
                <div class="metric-card">
                  <div class="metric-title">
                    {{
                      labelService.getLabel(
                        "Crediti Utilizzati Analisi Appuntamento"
                      )
                    }}
                    <mat-icon
                      class="info-icon"
                      matTooltip="I crediti si resettano automaticamente a 60 all'inizio di ogni mese"
                      >update</mat-icon
                    >
                  </div>
                  <div class="progress-bar-container">
                    <div
                      class="progress-bar"
                      [style.width]="
                        ((60 - usage.appointment_pipeline_credits) / 60) * 100 +
                        '%'
                      "
                      [class.warning]="
                        60 - usage.appointment_pipeline_credits > 40
                      "
                      [class.critical]="
                        60 - usage.appointment_pipeline_credits > 55
                      "
                    ></div>
                  </div>
                  <div class="metric-values">
                    <span>{{ 60 - usage.appointment_pipeline_credits }}</span>
                    <span class="total">/60</span>
                  </div>
                </div>
              </div>
            } @else {
              <div class="usage-status">
                <app-loader></app-loader>
              </div>
            }
          </section>
        </section>
      }

      @if (isDeletingAccount) {
        <div class="loading-container">
          <app-loader [size]="'big'"></app-loader>
        </div>
      }

      @if (!isDeletingAccount) {
        <section class="delete-account-section">
          <button mat-button (click)="onDeleteClick()">
            {{ labelService.getLabel("Elimina Account") }}
          </button>
        </section>
      }
    </section>
  </main>
</app-side-top-bar>
